'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/ArrowSquareOut.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var a = (e, r, o) => r in e ? i(e, r, { enumerable: true, configurable: true, writable: true, value: o }) : e[r] = o, m = (e, r) => {
  for (var o in r || (r = {}))
    c.call(r, o) && a(e, o, r[o]);
  if (t)
    for (var o of t(r))
      u.call(r, o) && a(e, o, r[o]);
  return e;
}, f = (e, r) => p(e, s(r));
const q = forwardRef((e, r) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: r }, e), { weights: t$1 })));
q.displayName = "ArrowSquareOut";
export {
  q as ArrowSquareOut
};
